import { render } from "./CompaniesOptions.vue?vue&type=template&id=94b1b046"
import script from "./CompaniesOptions.vue?vue&type=script&lang=js"
export * from "./CompaniesOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__